import {
  SeedInventoryCurrentMtApi,
  SeedInventoryApiRecord,
  SeedInventoryListMeta,
  SeedTracker,
  SeedTrackerDTO,
  SeedTrackerListRequestFilter,
  SeedTrackerListRequestSorting,
} from 'modules/domain/seedTracker/types'
import { apiClient } from 'modules/utils/httpClient'
import { endpoints } from 'modules/endpoints'
import { ListResponse } from 'types/api'

export const getSeedTrackersList = (
  filter: SeedTrackerListRequestFilter,
  sorting: SeedTrackerListRequestSorting,
  page: number,
  pageSize?: number,
) => {
  try {
    return apiClient.get<ListResponse<SeedTracker>>(endpoints.seedTrackers(), {
      ...filter,
      ...sorting,
      page: page,
      page_size: pageSize,
    })
  } catch (err) {
    console.error('SeedTrackers list fetch error!', err)
    throw err
  }
}

export const getSeedTracker = (id: string) => {
  try {
    return apiClient.get<SeedTracker>(endpoints.seedTrackers(id))
  } catch (err) {
    console.error('SeedTracker fetch error!', err)
    throw err
  }
}

export const addSeedTracker = (seedTracker: SeedTrackerDTO) => {
  return apiClient.post<SeedTracker>(endpoints.seedTrackers(), seedTracker)
}

export const updateSeedTracker = (id: string, seedTracker: Partial<SeedTrackerDTO>) => {
  return apiClient.put<SeedTracker>(endpoints.seedTrackers(id), seedTracker)
}

export const removeSeedTracker = (id: string) => {
  return apiClient.delete(endpoints.seedTrackers(id))
}

export const seedTrackersCount = async (filter: SeedTrackerListRequestFilter = {}) => {
  const response = await apiClient.get<ListResponse<SeedTracker>>(endpoints.seedTrackers(), {
    ...filter,
    page_size: 1,
  })
  return response.total_count
}

export type SeedInventoryListFilters = {
  companyId?: string
  seededPedigree?: string
  regionId?: string
  year?: string
}

export const listSeedInventoryByProductCard = (
  productCardId: string,
  page = 1,
  pageSize = 500,
  filters: SeedInventoryListFilters = {},
) =>
  apiClient.get<ListResponse<SeedInventoryApiRecord, SeedInventoryListMeta>>(endpoints.seedInventory(), {
    product_card_id: productCardId,
    page,
    page_size: pageSize,
    ...(filters.companyId ? { company_id: filters.companyId } : {}),
    ...(filters.seededPedigree ? { seeded_pedigree: filters.seededPedigree } : {}),
    ...(filters.regionId ? { region_id: filters.regionId } : {}),
    ...(filters.year ? { year: filters.year } : {}),
  })

export const createSeedInventory = (body: Record<string, unknown>) =>
  apiClient.post<SeedInventoryApiRecord>(endpoints.seedInventory(), body)

export const updateSeedInventory = (id: string, body: Record<string, unknown>) =>
  apiClient.put<SeedInventoryApiRecord>(endpoints.seedInventory(id), body)

export const deleteSeedInventory = (id: string) => apiClient.delete(endpoints.seedInventory(id))

export const getSeedInventoryCurrentMt = (params: {
  product_card_id: string
  company_id: string
  seeded_pedigree: string
}) => apiClient.get<SeedInventoryCurrentMtApi>(endpoints.seedInventoryCurrentMt(), params)
